import {
  H4_SERVICES_IMG01,
  H4_SERVICES_IMG02,
  H4_SERVICES_IMG03,
  H4_SERVICES_IMG04,
  SERVICES_IMG01,
  SERVICES_IMG02,
  SERVICES_IMG03,
  SERVICES_ITEM_SHAPE,
} from "../lib/assets";
import { getServiceHref } from "../data/bookkeepingServices";
import serviceImg01 from "../assets/img/services-two/service_01.jpg";
import serviceImg02 from "../assets/img/services-two/service_02.jpg";
import serviceImg03 from "../assets/img/services-two/service_03.jpg";
import serviceImg04 from "../assets/img/services-two/service_04.jpg";

export const SERVICES_TWO_LIST = [
  {
    id: 1,
    src: serviceImg01,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-piggy-bank",
    href: getServiceHref("Startup Bookkeeping"),
    title: "Startup Bookkeeping",
    subtitle: "New business? Get your books set up right from day one.",
  },
  {
    id: 2,
    src: serviceImg02,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-calculator",
    href: getServiceHref("Monthly Bookkeeping"),
    title: "Monthly Bookkeeping",
    subtitle: "Transactions recorded, reconciled and reported every month.",
  },
  {
    id: 3,
    src: serviceImg03,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-money",
    href: getServiceHref("Catch-Up Bookkeeping"),
    title: "Catch-Up Bookkeeping",
    subtitle: "Months behind? We bring your books up to date.",
  },
  {
    id: 4,
    src: serviceImg04,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-layers",
    href: getServiceHref("QuickBooks & Xero Setup"),
    title: "QuickBooks & Xero Setup",
    subtitle: "Your software set up properly, with training included.",
  },
];

export const SERVICES_THREE_LIST = [
  {
    id: 1,
    src: H4_SERVICES_IMG01,
    icon: "flaticon-healthcare",
    href: "/services-details",
    title: "Health Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 2,
    src: H4_SERVICES_IMG02,
    icon: "flaticon-protection",
    href: "/services-details",
    title: "Vehicle Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 3,
    src: H4_SERVICES_IMG03,
    icon: "flaticon-ship",
    href: "/services-details",
    title: "Cargo Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 4,
    src: H4_SERVICES_IMG04,
    icon: "flaticon-house",
    href: "/services-details",
    title: "Fire Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
];

export const SERVICES_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-business-presentation",
    href: "/services-details",
    title: "Marketing Strategy",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
  {
    id: 2,
    icon: "flaticon-rocket",
    href: "/services-details",
    title: "SEO Consultancy",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
  {
    id: 3,
    icon: "flaticon-mission",
    href: "/services-details",
    title: "Target Audience",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
];

export const SERVICES_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-rocket",
    href: getServiceHref("Startup Bookkeeping"),
    src: SERVICES_IMG01,
    title: "Startup Bookkeeping",
    subtitle: "Books set up right from day one for new businesses.",
    list: [
      "Setup for your business model",
      "Payment apps connected",
      "Business and personal money separated",
    ],
  },
  {
    id: 2,
    icon: "flaticon-calculator",
    href: getServiceHref("Monthly Bookkeeping"),
    src: SERVICES_IMG02,
    title: "Monthly Bookkeeping",
    subtitle: "Transactions recorded, reconciled and reported every month.",
    list: [
      "Bank and card reconciliations",
      "Monthly profit & loss report",
      "Books closed by the 15th",
    ],
  },
  {
    id: 3,
    icon: "flaticon-folder",
    href: getServiceHref("Catch-Up Bookkeeping"),
    src: SERVICES_IMG03,
    title: "Catch-Up Bookkeeping",
    subtitle: "Months or years behind? We bring your books up to date.",
    list: [
      "Flat-fee quote up front",
      "Missing records tracked down",
      "Ready for your tax preparer",
    ],
  },
  {
    id: 4,
    icon: "flaticon-report",
    href: getServiceHref("QuickBooks & Xero Setup"),
    src: SERVICES_IMG01,
    title: "QuickBooks & Xero Setup",
    subtitle: "Your accounting software set up properly, with training.",
    list: [
      "Chart of accounts setup",
      "Bank feeds connected",
      "One-on-one training",
    ],
  },
  {
    id: 5,
    icon: "flaticon-briefcase",
    href: getServiceHref("Trucking Bookkeeping"),
    src: SERVICES_IMG02,
    title: "Trucking Bookkeeping",
    subtitle: "Bookkeeping for owner-operators and fleets.",
    list: [
      "Cost per truck tracking",
      "Fuel and maintenance records",
      "Settlement reconciliation",
    ],
  },
  {
    id: 6,
    icon: "flaticon-house",
    href: getServiceHref("Construction Bookkeeping"),
    src: SERVICES_IMG03,
    title: "Construction Bookkeeping",
    subtitle: "Bookkeeping for contractors and trades, set up around your jobs.",
    list: [
      "Job costing",
      "Holdback tracking",
      "Subcontractor payment records",
    ],
  },
];
